import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-signup-terms',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './signup-terms.component.html',
  styleUrl: './signup-terms.component.scss'
})
export class SignupTermsComponent implements OnInit, OnDestroy {
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @Output() onTermsAccept: EventEmitter<any> = new EventEmitter<any>();
  supportEmail = 'Support@TaxPlanIQ.com';
  constructor() {}

  ngOnInit() {
  }

  acceptTerms() {
    this.onTermsAccept.emit();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
